import React, { useRef } from 'react';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Editing,
  Form,
  Button as GridButton,
  Toolbar,
  Item as GridItem,
  DataGridRef,
  Popup,
  HeaderFilter
} from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';
import { dataGridErrorHandling } from '../../utils/errorHandling';
import { GroupItem, Item } from "devextreme-react/form";
import { useUsersDataSource } from '../../datasources/UsersDataSource';
import PopupSendInvite, { SendInvitePopupHandle } from '../popupSendInvite/popupSendInvite';
import { RoleDTO } from '../../data';
import PopupPendingInvite, { PendingInvitePopupHandle } from './popupPendingInvite';

type Props = {
  onchanged?: () => void;
}

export type UtentiPanelHandle = {}

const UtentiPanel: React.ForwardRefRenderFunction<UtentiPanelHandle> = (props, ref) => {
  const dataSource = useUsersDataSource();
  const gridRef = useRef(null);
  const sendInviteRef = useRef<SendInvitePopupHandle>(null);
  const pendingInviteRef = useRef<PendingInvitePopupHandle>(null);

  //   const handleInitNewRow = (e:any) => {
  //     e.cancel = true; // blocca il comportamento predefinito
  //     sendInviteRef.current?.show(0); // mostra il popup per inviare l'invito
  //   };


  return (
    <React.Fragment>
      <DataGrid
        dataSource={dataSource}
        ref={gridRef}
        onDataErrorOccurred={dataGridErrorHandling}
        onRowUpdating={e => e.newData = Object.assign({}, e.oldData, e.newData)}
      >
        <Editing
          mode="popup"
          allowUpdating={false}
          allowAdding={true}
          allowDeleting={true}>
          <Popup title="Utenti" showTitle={true} />
          <Form colCount={2}>
            <Item dataField="givename" editorType='dxTextBox' />
            <Item dataField="surname" editorType='dxTextBox' />
            <Item dataField="email" editorType='dxTextBox' colSpan={2} />
          </Form>
        </Editing>
        <HeaderFilter visible={true} allowSearch={true} />
         <Column type='buttons' alignment='left'></Column>
        <Column dataField={'id'} width={90} allowEditing={false} visible={false} />
        <Column dataField={'givename'} caption={'Nome'} />
        <Column dataField={'surname'} caption={'Cognome'} />
        <Column dataField={'email'} caption={'Email'} />
        <Column dataField={'roles'} caption={'Ruoli'} calculateCellValue={(rowData) => {
          return (rowData.roles || [])
            .map((role: RoleDTO) => role.id)
            .filter(Boolean) // rimuove null/undefined
            .join(", ");
        }} />

        <Toolbar>
          <GridItem location="after">
            <Button
              icon='runner'
              hint='Elenco degli inviti in sospeso'
              stylingMode="text"
              onClick={() => pendingInviteRef.current?.show()}
            />
            <Button
              icon='add'
              hint='Invia un invito per un nuovo utente'
              stylingMode="text"
              onClick={() => sendInviteRef.current?.inviteUser()}
            />

          </GridItem>
        </Toolbar>
      </DataGrid>

      <PopupSendInvite ref={sendInviteRef} />
      <PopupPendingInvite ref={pendingInviteRef} />
    </React.Fragment>
  );
}

export default React.forwardRef(UtentiPanel);
